import React, { Component } from "react";

export default class Datablock extends Component {
  render() {
    return (
      <div className="columns datablock">
        <div className="dblockimg">
          {this.props.img ? (
            <img
              alt="alt-text"
              src={this.props.img}
              className="datablock-img"
            />
          ) : null}
        </div>
        <div className="dblocktxt">
          <span className="dblock-text">{this.props.title}</span>
          <span className="dblock-number">
            {Number(this.props.number).toLocaleString()}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Datablock.js